import React, { useEffect, useMemo, useState } from "react";
import "../../styles/AdminAdminsPage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const api = axios.create({ baseURL: "/api" });

export default function AdminAdminsPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  const currentUser = useMemo(() => {
    return JSON.parse(localStorage.getItem("currentUser") || "null");
  }, []);

  const isSuperAdmin = useMemo(() => {
    return currentUser?.email === "admin@live-evo.com" || currentUser?.role === "super_admin";
  }, [currentUser]);

  async function loadStaff() {
    setLoading(true);
    try {
      // On récupère les users filtrables, et on filtre staff côté front (simple)
      const { data } = await api.get("/admin/users", {
        params: { search, role: "", status: "", page: 1, limit: 100 },
      });
      setUsers(data.users || []);
    } finally {
      setLoading(false);
    }
  }

  async function updateRole(userId, role) {
    setLoading(true);
    try {
      await api.put(`/admin/users/${userId}/role`, { role });
      await loadStaff();
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!isSuperAdmin) return;
    const t = setTimeout(() => loadStaff(), 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [search, isSuperAdmin]);

  // 🔒 Protection côté front (en + du backend)
  if (!isSuperAdmin) {
    return (
      <div className="admin-admins-page">
        <div className="admins-card">
          <h1>⛔ Accès réservé</h1>
          <p>Cette page est uniquement accessible au Super Admin.</p>
          <button className="btn neon" onClick={() => navigate("/admin")}>Retour Admin</button>
        </div>
      </div>
    );
  }

  const staff = (users || []).filter(u => ["admin", "moderator", "super_admin"].includes(u.role));

  return (
    <div className="admin-admins-page">
      <div className="admins-header">
        <div className="title">
          <span className="ico">🛡</span>
          <div>
            <h1>Admins & Droits</h1>
            <p>Page Super Admin — ici tu ajoutes / retires des admins et tu gères les rôles.</p>
          </div>
        </div>

        <div className="search">
          <span className="sico">🔎</span>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher un staff (pseudo, email, ID)…"
          />
        </div>
      </div>

      <div className="admins-grid">
        <div className="admins-card">
          <h2>📌 Staff actuel</h2>

          {loading ? (
            <div className="box">Chargement…</div>
          ) : staff.length === 0 ? (
            <div className="box">Aucun admin/modo trouvé.</div>
          ) : (
            <div className="list">
              {staff.map((u) => (
                <div key={u.id} className="row">
                  <div className="left">
                    <div className="avatar">{u.role === "super_admin" ? "👑" : "🛡"}</div>
                    <div>
                      <div className="name">{u.pseudo || "Sans pseudo"}</div>
                      <div className="sub">{u.email}</div>
                    </div>
                  </div>

                  <div className="right">
                    <span className={`pill role-${u.role}`}>{u.role}</span>

                    {/* 🔒 Super admin protégé */}
                    {u.role === "super_admin" ? (
                      <span className="protected">Protégé</span>
                    ) : (
                      <select
                        value={u.role}
                        onChange={(e) => updateRole(u.id, e.target.value)}
                        disabled={loading}
                      >
                        <option value="user">user</option>
                        <option value="moderator">moderator</option>
                        <option value="admin">admin</option>
                      </select>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="admins-card">
          <h2>➕ Ajouter un admin / modérateur</h2>
          <div className="box">
            <p>
              Pour l’instant (simple & safe) : tu prends un user existant dans <b>/admin/users</b>,
              puis ici tu changes son rôle en <b>admin</b> ou <b>moderator</b>.
            </p>
            <p style={{opacity:0.8}}>
              Ensuite on ajoutera : invitations email + permissions fines (cases à cocher).
            </p>
          </div>

          <button className="btn neon" onClick={() => navigate("/admin/users")}>
            Ouvrir Gestion Utilisateurs
          </button>
        </div>
      </div>
    </div>
  );
}
